import { GroupPanelNewProps, GroupsPanel } from '@juvare/contact-management/ui/features/groups/components/GroupsPanel';
import React from 'react';

type RmsGroupsPanelProps = GroupPanelNewProps;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RmsGroupsPanel: React.FC<RmsGroupsPanelProps> = GroupsPanel as any;
